import { NgModule } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { BrowserModule } from '@angular/platform-browser';
import { UIRouterModule } from '@uirouter/angular';
import { Ng2Webstorage } from 'ngx-webstorage';
import { MarkdownModule } from 'ngx-markdown';

import { PlatonSharedModule } from './shared';
import { PlatonAdminModule } from './admin/admin.module';
import { PlatonScreensModule } from './_screens/_screens.module';

import { AuthModule } from './shared/auth/auth.module';

import { appState } from './app.state';
import { HomeComponent, homeState } from './home';
import { configureRouter } from './blocks/config/router.config';
import { customHttpClientProvider } from './blocks/interceptor/http.provider';
import { PaginationConfig } from './blocks/config/uib-pagination.config';

import {
    accessdeniedState,
    ActiveMenuDirective,
    ErrorComponent,
    errorState,
    FooterComponent,
    JhiMainComponent,
    NavbarComponent,
    PageRibbonComponent,
    ProfileService,
} from './layouts';

import { SessionStaffingService, TrainerService } from './_services';
import { ToasterComponent, ToasterService } from './_screens/_shared/toaster';
import { DownloadWithToastsService } from './_screens/_shared/download-with-toasts';

registerLocaleData(localeFr);

let routerConfig = {
    config: configureRouter,
    otherwise: '/',
    useHash: true,
    states: [appState, homeState, errorState, accessdeniedState],
};

@NgModule({
    imports: [
        BrowserModule,
        AuthModule,
        UIRouterModule.forRoot(routerConfig),
        Ng2Webstorage.forRoot({ prefix: 'jhi' }),
        MarkdownModule.forRoot(),
        PlatonSharedModule,
        PlatonAdminModule,
        PlatonScreensModule,
    ],
    declarations: [
        JhiMainComponent,
        HomeComponent,
        NavbarComponent,
        ErrorComponent,
        ActiveMenuDirective,
        FooterComponent,
        ToasterComponent,
        PageRibbonComponent,
    ],
    entryComponents: [ToasterComponent],
    providers: [
        ProfileService,
        SessionStaffingService,
        TrainerService,
        ...customHttpClientProvider,
        PaginationConfig,
        ToasterService,
        DownloadWithToastsService,
    ],
    bootstrap: [JhiMainComponent],
})
export class PlatonAppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts